module.exports = __webpack_public_path__ + "img/real_name.24622fc3.svg";